import { t } from 'i18next';
import * as yup from 'yup';

import { AutocompleteFieldOption } from '~components/FormFields/v2/Autocomplete/types';
import { autocompleteOptionSchema } from '~constants/regexConst';
import { Account } from '~hooks/useAccount/models';
import { Rate } from '~hooks/useRates/models';

const requiredAutocompleteOptionSchema = autocompleteOptionSchema.required(
  t('form_validation_errors.required_simple'),
);
const notRequiredAutocompleteOptionsSchema = yup
  .array()
  .of(requiredAutocompleteOptionSchema)
  .notRequired();

export const rateCopyToFormSchema = yup.object().shape({
  name: yup.string().trim().required(t('form_validation_errors.required_simple')),
  account: autocompleteOptionSchema.required(t('form_validation_errors.required_simple')),
  projects: notRequiredAutocompleteOptionsSchema,
  equipments: notRequiredAutocompleteOptionsSchema,
  services: notRequiredAutocompleteOptionsSchema,
});

export type RateCopyToFormDto = yup.InferType<typeof rateCopyToFormSchema>;

export function setRateCopyToFormDefaultValues(rate: Rate) {
  const defaultValues: RateCopyToFormDto = {
    name: rate.name,
    account: null as unknown as AutocompleteFieldOption<Account>,
    projects: [],
    equipments: [],
    services: [],
  };

  return defaultValues;
}
